// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.prof-menu {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(720px, 92vw);
  height: min(660px, 90vh);
  display: flex;
  flex-direction: column;
  z-index: 45;
  overflow: hidden;
}
.prof-menu * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .prof-menu {
    animation: none;
  }
}
.prof-menu__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px 6px;
}
.prof-menu__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin: 0;
}
.prof-menu__sub {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin: 4px 0 0;
}
.prof-menu__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  padding: 5px 10px;
  font-size: 13px;
}
.prof-menu__close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.prof-menu__close:active:not(:disabled) {
  transform: translateY(1px);
}
.prof-menu__close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.prof-menu__close:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.prof-menu__close:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.prof-menu__student {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 8px 18px 0;
  padding: 10px 14px;
}
.prof-menu__student.is-blocked {
  border-color: rgba(217, 120, 109, 0.45);
}
.prof-menu__student-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.prof-menu__student-label {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  font-size: 12px;
}
.prof-menu__student-name {
  font-size: 16px;
  font-weight: 600;
  color: #ebe8e1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.prof-menu__student-reason {
  font-size: 13px;
  color: #d9786d;
}
.prof-menu__link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  padding: 5px 10px;
  font-size: 13px;
  color: var(--gold-light);
}
.prof-menu__link:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.prof-menu__link:active:not(:disabled) {
  transform: translateY(1px);
}
.prof-menu__link:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.prof-menu__link:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.prof-menu__link:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.prof-menu__tools {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 18px 0;
}
.prof-menu__search {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
}
.prof-menu__search:focus {
  outline: none;
  border-color: var(--gold-main);
}
.prof-menu__search::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.prof-menu__schools {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.prof-menu__school {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  padding: 5px 10px;
  font-size: 13px;
  background: transparent;
  color: #aeaba2;
}
.prof-menu__school:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.prof-menu__school:active:not(:disabled) {
  transform: translateY(1px);
}
.prof-menu__school:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.prof-menu__school:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.prof-menu__school.is-active {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.prof-menu__count {
  display: inline-block;
  min-width: 20px;
  padding: 1px 7px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.09);
  border-radius: 10px;
  margin-left: 2px;
  color: inherit;
  background: rgba(0, 0, 0, 0.18);
}
.prof-menu__status {
  margin: 10px 18px 0;
  padding: 8px 12px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.prof-menu__status.is-ok {
  color: #8fbf8a;
  border-color: rgba(143, 191, 138, 0.4);
}
.prof-menu__status.is-error {
  color: #d9786d;
  border-color: rgba(217, 120, 109, 0.45);
}
.prof-menu__list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
  margin: 12px 0 0;
  padding: 0 18px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.prof-menu__list::-webkit-scrollbar {
  width: 6px;
}
.prof-menu__list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.prof-menu__empty {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin: 18px 0;
  text-align: center;
}
.prof-menu__row {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
}
.prof-menu__row-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.prof-menu__row-name {
  font-size: 15px;
  font-weight: 600;
  color: #ebe8e1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.prof-menu__row-meta {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  font-size: 12px;
}
.prof-menu__known {
  display: inline-block;
  min-width: 20px;
  padding: 1px 7px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.09);
  border-radius: 10px;
  color: #8fbf8a;
}
.prof-menu__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  padding: 5px 10px;
  font-size: 13px;
  min-width: 96px;
}
.prof-menu__action:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.prof-menu__action:active:not(:disabled) {
  transform: translateY(1px);
}
.prof-menu__action:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.prof-menu__action:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.prof-menu__action.is-teach {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.prof-menu__action.is-teach:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.prof-menu__action.is-remove {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.prof-menu__action.is-remove:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.prof-menu__more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  align-self: center;
  margin-top: 6px;
}
.prof-menu__more:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.prof-menu__more:active:not(:disabled) {
  transform: translateY(1px);
}
.prof-menu__more:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.prof-menu__more:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.prof-menu__foot {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  padding: 8px 18px 12px;
  font-size: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/profMenu/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AANA;ED8BE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;ECxKA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AAcF;ADME;EAAI,sBAAA;ACHN;ADgJE;EC7KF;ID6K4C,eAAA;EC5I1C;AACF;AApBE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,sBAAA;AAsBJ;AAnBE;ED+BA,kDA3BW;EA4BX,gBAAA;EACA,eChCqB;EDiCrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECMH,SAAA;AA0BJ;AAvBE;EDyCA,eAAA;EACA,gBAAA;EACA,cAlDO;ECSL,eAAA;AA2BJ;AAxBE;EDiDA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;EAMA,iBAAA;EACA,eAAA;ACnDF;ADmBE;EAAyB,qCAAA;EAAuC,8BAAA;ACflE;ADgBE;EAA0B,0BAAA;ACb5B;ADcE;EAAa,YAAA;EAAc,mBAAA;ACV7B;ADWE;EAAkB,oCAAA;EAAsC,mBAAA;ACP1D;AD+BE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;AC1BhF;AA5DE;EDQA,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;ECkBL,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;AAgEJ;AA9DI;EAAe,uCAAA;AAiEnB;AA9DE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAgEJ;AA7DE;EDUA,eAAA;EACA,gBAAA;EACA,cAlDO;ECwCL,eAAA;AAiEJ;AA9DE;EACE,eAAA;EACA,gBAAA;EACA,cDhDG;ECiDH,gBAAA;EACA,uBAAA;EACA,mBAAA;AAgEJ;AA7DE;EACE,eAAA;EACA,cDrDK;ACoHT;AA5DE;EDIA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;EAMA,iBAAA;EACA,eAAA;ECjDE,wBAAA;AAgFJ;AD/DE;EAAyB,qCAAA;EAAuC,8BAAA;ACmElE;ADlEE;EAA0B,0BAAA;ACqE5B;ADpEE;EAAa,YAAA;EAAc,mBAAA;ACwE7B;ADvEE;EAAkB,oCAAA;EAAsC,mBAAA;AC2E1D;ADnDE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACwDhF;AAjGE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oBAAA;AAmGJ;AAhGE;ED2CA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ACwDF;ADtDE;EAAU,aAAA;EAAe,8BAAA;AC0D3B;ADzDE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACgE1G;AAlHE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAoHJ;AAjHE;EDpBA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAiCA,iBAAA;EACA,eAAA;EC1BE,uBAAA;EACA,cDtFK;ACyNT;AD1IE;EAAyB,qCAAA;EAAuC,8BAAA;AC8IlE;AD7IE;EAA0B,0BAAA;ACgJ5B;AD/IE;EAAa,YAAA;EAAc,mBAAA;ACmJ7B;ADlJE;EAAkB,oCAAA;EAAsC,mBAAA;ACsJ1D;AAhJI;EACE,cDpFM;ECqFN,4BAAA;EACA,8BAAA;AAkJN;AA9IE;EDoCA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAzIO;EA0IP,qCAAA;EACA,mBAAA;EC1CE,gBAAA;EACA,cAAA;EACA,+BAAA;AAwJJ;AArJE;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBDtGK;ECuGL,0CAAA;AAuJJ;AArJI;EAAU,cD1GJ;EC0GyB,sCAAA;AAyJnC;AAxJI;EAAa,cD5GR;EC4G4B,uCAAA;AA4JrC;AAzJE;ED8BA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC9BE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA6JJ;ADnIE;EAAuB,UAAA;ACsIzB;ADrIE;EAA6B,oCAAA;EAAsC,kBAAA;ACyIrE;AAjKE;ED3EA,eAAA;EACA,gBAAA;EACA,cAlDO;EC6HL,cAAA;EACA,kBAAA;AAqKJ;AAlKE;EDtGA,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;ECgIL,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAsKJ;AAnKE;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAqKJ;AAlKE;EACE,eAAA;EACA,gBAAA;EACA,cDtJG;ECuJH,gBAAA;EACA,uBAAA;EACA,mBAAA;AAoKJ;AAjKE;ED1GA,eAAA;EACA,gBAAA;EACA,cAlDO;EC4JL,eAAA;AAqKJ;AAlKE;ED7BA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAzIO;EA0IP,qCAAA;EACA,mBAAA;ECuBE,cD/JM;AC2UV;AAzKE;EDvGA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAiCA,iBAAA;EACA,eAAA;ECyDE,eAAA;AA2LJ;ADpRE;EAAyB,qCAAA;EAAuC,8BAAA;ACwRlE;ADvRE;EAA0B,0BAAA;AC0R5B;ADzRE;EAAa,YAAA;EAAc,mBAAA;AC6R7B;AD5RE;EAAkB,oCAAA;EAAsC,mBAAA;ACgS1D;AAxMI;EDpFF,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC+RF;AD7RE;EAAyB,6BAAA;EAA+B,+BAAA;ACiS1D;AAhNI;ED7EF,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACgSF;AD9RE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACkYT;AAtNE;EDhHA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;ECmGE,kBAAA;EACA,eAAA;AAuOJ;ADzUE;EAAyB,qCAAA;EAAuC,8BAAA;AC6UlE;AD5UE;EAA0B,0BAAA;AC+U5B;AD9UE;EAAa,YAAA;EAAc,mBAAA;ACkV7B;ADjVE;EAAkB,oCAAA;EAAsC,mBAAA;ACqV1D;AAnPE;EDnIA,eAAA;EACA,gBAAA;EACA,cAlDO;ECqLL,sBAAA;EACA,eAAA;EACA,+CAAA;AAuPJ","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Teaching menu: a centred panel, the world stays visible around it.\n.prof-menu {\n  @include ink.panel;\n  @include ink.enter;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(720px, 92vw);\n  height: min(660px, 90vh);\n  display: flex;\n  flex-direction: column;\n  z-index: 45;\n  overflow: hidden;\n\n  &__head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 16px 18px 6px;\n  }\n\n  &__title {\n    @include ink.title(22px);\n    margin: 0;\n  }\n\n  &__sub {\n    @include ink.hint;\n    margin: 4px 0 0;\n  }\n\n  &__close {\n    @include ink.button;\n    @include ink.button-quiet;\n    @include ink.button-sm;\n  }\n\n  // Who receives the spells\n  &__student {\n    @include ink.block;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin: 8px 18px 0;\n    padding: 10px 14px;\n\n    &.is-blocked { border-color: rgba(217, 120, 109, 0.45); }\n  }\n\n  &__student-text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n  }\n\n  &__student-label {\n    @include ink.hint;\n    font-size: 12px;\n  }\n\n  &__student-name {\n    font-size: 16px;\n    font-weight: 600;\n    color: ink.$text;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__student-reason {\n    font-size: 13px;\n    color: ink.$danger;\n  }\n\n  &__link {\n    @include ink.button;\n    @include ink.button-quiet;\n    @include ink.button-sm;\n    color: var(--gold-light);\n  }\n\n  &__tools {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 12px 18px 0;\n  }\n\n  &__search {\n    @include ink.field;\n  }\n\n  &__schools {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  &__school {\n    @include ink.button;\n    @include ink.button-sm;\n    background: transparent;\n    color: ink.$text-2;\n\n    &.is-active {\n      color: ink.$on-accent;\n      background: var(--gold-main);\n      border-color: var(--gold-main);\n    }\n  }\n\n  &__count {\n    @include ink.badge;\n    margin-left: 2px;\n    color: inherit;\n    background: rgba(0, 0, 0, 0.18);\n  }\n\n  &__status {\n    margin: 10px 18px 0;\n    padding: 8px 12px;\n    font-size: 14px;\n    border-radius: ink.$radius;\n    border: 1px solid ink.$line-strong;\n\n    &.is-ok { color: ink.$success; border-color: rgba(143, 191, 138, 0.4); }\n    &.is-error { color: ink.$danger; border-color: rgba(217, 120, 109, 0.45); }\n  }\n\n  &__list {\n    @include ink.scroll;\n    flex: 1;\n    min-height: 0;\n    margin: 12px 0 0;\n    padding: 0 18px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  &__empty {\n    @include ink.hint;\n    margin: 18px 0;\n    text-align: center;\n  }\n\n  &__row {\n    @include ink.block;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 12px;\n  }\n\n  &__row-text {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    min-width: 0;\n  }\n\n  &__row-name {\n    font-size: 15px;\n    font-weight: 600;\n    color: ink.$text;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__row-meta {\n    @include ink.hint;\n    font-size: 12px;\n  }\n\n  &__known {\n    @include ink.badge;\n    color: ink.$success;\n  }\n\n  &__action {\n    @include ink.button;\n    @include ink.button-sm;\n    min-width: 96px;\n\n    &.is-teach { @include ink.button-primary; }\n    &.is-remove { @include ink.button-danger; }\n  }\n\n  &__more {\n    @include ink.button;\n    align-self: center;\n    margin-top: 6px;\n  }\n\n  &__foot {\n    @include ink.hint;\n    padding: 8px 18px 12px;\n    font-size: 12px;\n    border-top: 1px solid ink.$line;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
